<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <app-table  hide-upsert :config="config" title="Countries Data" upsert-max-width="650px">
        </app-table>
      </v-flex>
    </v-layout>
    <app-upsert-countrydata v-model="openUpsertModal" :section="section" :item="item" @close="openUpsertModal = false" />
  </v-container>
</template>

<script>
import config from './config_index.js'

export default {
  data () {
    return { 
      config,
      openUpsertModal: false,
      item: {},
      section: ''
    }
  },
  mounted() {
    config.setApp(this)
  },
  methods: {
    upsert(item, section) {
       this.section = section
       this.item = item
       this.openUpsertModal = true
    },
  }
}
</script>
